import type { SuperValidated } from 'sveltekit-superforms';

import { z } from 'zod';

const inquiry = z.enum(
  ['general_issue', 'technical_problem', 'request_or_suggest_a_feature', 'cooperation_and_partnership'],
  {
    required_error: 'Inquiry is required',
  },
);

export type ReportForm = SuperValidated<typeof reportForm>;

export const reportForm = z.object({
  inquiry: inquiry,
  name: z.string().min(1, 'Name is required').max(124),
  email: z.string().min(1, 'Email is required').trim().email('Email is not valid'),
  message: z.string().min(1, 'Message is required'),
});
